
const digest = '99bda8107193e917c2e077044b47ea724981e1f1c307a087245cbce5eaac6776';
const classes = {"wrapper":"_wrapper_1yz5l_1"};
const css = `._wrapper_1yz5l_1 {
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  